<template>
  <footer class="main-footer" :class="ftshow">
    <a href="#" class="scroll-top" :class="scTop" @click="scrollTop">ページトップ</a>

    <div class="ftinner">
      <div class="box">
        <h2 class="ftlogo"><a href="https://www.allgrow.co.jp/" class="logolink" target="_blank">オルグロー株式会社</a></h2>
        <p class="address">
          〒150-0045 東京都渋谷区神泉町10-10<br>
          VORT渋谷新泉ビル 6F<br>
          <a href="https://www.allgrow.co.jp/" class="linktxt" target="_blank">https://www.allgrow.co.jp/</a>
        </p>

      </div><!-- .box -->
      <div class="box -right">
        <ul class="ftnav">
          <li class="ftnlist"><a href="/terms.php" class="ftnlink" target="_blank">利用規約</a></li>
          <li class="ftnlist"><a href="https://www.allgrow.co.jp/privacy.html" class="ftnlink" target="_blank">プライバシーポリシー</a></li>
        </ul>
        <p class="copy">&copy;2012-2020 ALLGROW Inc</p>

      </div><!-- .box -->
    </div><!-- .ftinner -->

  </footer>
</template>

<script>
export default {
  data() {
    return {
      scrollY: window.pageYOffset,
      scTop: "",
      ftshow: ""
    };
  },
  methods: {
    scrollTop(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll: function () {
      this.scrollY = window.pageYOffset;
      // console.log(this.scrollY);
      if (this.scrollY >= 500) {
        this.scTop = "-active";
      } else {
        this.scTop = "";
      }
    }    
  },
  mounted: function () {
    window.addEventListener("scroll", this.handleScroll);
    this.ftshow = "-active";
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },  
};
</script>

<style lang="scss" scoped>
.main-footer{
  background-color: #ebf4f8;
  padding: 30px 10px;
  box-sizing: border-box;
  opacity: 0;
  &.-active{
    opacity: 1;
    animation: footeranim 1s linear 0s;
    animation-fill-mode: forwards;  
  }
}
@keyframes footeranim {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
  
}
</style>